export default __webpack_public_path__ + "static/media/droom.de8669c9.svg";